import { Toggle } from '@base-ui/react/toggle';
import { ToggleGroup } from '@base-ui/react/toggle-group';
import { css } from 'aphrodite';
import * as React from 'react';
import { s } from './styles';

export interface TabToggleItem {
	value: string;
	label: string;
	disabled?: boolean;
}

export interface TabToggleProps
	extends AphroditeStyled<
		Omit<React.ComponentProps<typeof ToggleGroup>, 'value' | 'defaultValue' | 'onValueChange' | 'multiple'>
	> {
	items: TabToggleItem[];
	value?: string;
	defaultValue?: string;
	onValueChange?: (value: string) => void;
}

export function TabToggle({ items, value, defaultValue, onValueChange, styles = [], ...props }: TabToggleProps) {
	const handleValueChange = (groupValue: string[]) => {
		if (groupValue.length > 0) {
			onValueChange?.(groupValue[0]);
		}
	};

	return (
		<ToggleGroup
			data-slot='tab-toggle'
			className={css(s.root, ...styles)}
			value={value !== undefined ? [value] : undefined}
			defaultValue={defaultValue !== undefined ? [defaultValue] : undefined}
			onValueChange={handleValueChange}
			multiple={false}
			{...props}
		>
			{items.map(item => (
				<Toggle
					key={item.value}
					value={item.value}
					disabled={item.disabled}
					className={css(s.item)}
					data-slot='tab-toggle-item'
				>
					{item.label}
				</Toggle>
			))}
		</ToggleGroup>
	);
}
